define(
    'utils/url-hash-manager',[],

    function () {
        return (function () {
            /**
             * @class UrlHashManager
             * @constructor
             */
            function UrlHashManager () {}

            /**
             * Gets all the key value pairs stored in the url-hash
             *
             * @method getAll
             * @returns {*}
             */
            UrlHashManager.prototype.getAll = function () {
                var hash = location.hash.substr(1);

                if (hash) {
                    return this._decode(hash);
                }

                return {};
            };

            /**
             * Get the value of a specified key
             *
             * @method get
             * @param {String} key
             * @returns {String}
             */
            UrlHashManager.prototype.get = function (key) {
                return this.getAll()[key];
            };

            /**
             * Add a value to the url-hash
             *
             * @method add
             * @param {String} key
             * @param {Array} value
             */
            UrlHashManager.prototype.add = function (key, value) {
                var data = this.getAll();

                data[key] = value;

                location.hash = this._encode(data);
            };

            /**
             * Appends a value to an existing key in the url-hash if it
             * exists, otherwise creates it
             *
             * @method append
             * @param {String} key
             * @param {Array} value
             */
            UrlHashManager.prototype.append = function (key, value) {
                var data = this.getAll();

                if (data[key] !== undefined) {
                    for (var i = 0; i < value.length; i++) {
                        data[key].push(value[i]);
                    }
                } else {
                    data[key] = value;
                }

                location.hash = this._encode(data);
            };

            /**
             * Only removes the specified value from the specified key
             * in the url-hash, unlinke the remove function which removes
             * the entire key
             *
             * @method subtract
             * @param {String} key
             * @param {Array} value
             * @see remove
             */
            UrlHashManager.prototype.subtract = function (key, value) {
                var data = this.getAll();

                if (data[key] !== undefined) {
                    var values = data[key];

                    for (var i = 0; i < values.length; i++) {
                        for (var n = 0; n < value.length; n++) {
                            if (values[i] === value[n]) {
                                values.splice(i, 1);
                            }
                        }
                    }

                    if (values.length > 0) {
                        data[key] = values;
                    } else {
                        delete data[key];
                    }
                }

                location.hash = this._encode(data);
            };

            /**
             * Remove a single value from the url-hash
             *
             * @method remove
             * @param {String} key
             */
            UrlHashManager.prototype.remove = function (key) {
                var data = this.getAll();

                delete data[key];

                location.hash = this._encode(data);
            };


            /**
             * Clear url-hash
             * 
             * @method removeAll
             */
            UrlHashManager.prototype.removeAll = function () {
                location.hash = '';
            };


            /**
             * Encodes an JS object to the url-hash syntax
             *
             * @method _encode
             * @param {Object} data
             * @returns {string}
             * @private
             */
            UrlHashManager.prototype._encode = function (data) {
                var key, hashString = '';

                for (key in data) {
                    hashString += '&' + key + '=' + encodeURI(data[key].join(','));
                }

                return hashString.substr(1);
            };

            /**
             * Decodes the url-hash syntax into a JS object
             *
             * @method _decode
             * @param {String} raw
             * @returns {Object}
             * @private
             */
            UrlHashManager.prototype._decode = function (raw) {
                var regex = new RegExp('([^=&]+)=([^=]+)(?=&|$)', 'g'),
                    match,
                    result = {};

                while ((match = regex.exec(raw)) !== null) {
                    result[match[1]] = decodeURI(match[2]).split(',');
                }

                return result;
            };

            return UrlHashManager;
        })();
    }
);
